<template>
    <div class="p-4">
        <ui-form-section class="mb-4" :title="item.supplier">
            <ui-input label="Purchase Cost" name="cost" :error="form.errors.get('cost')" v-model="form.cost"></ui-input>
            <ui-input label="SKU" name="sku" :error="form.errors.get('sku')" v-model="form.sku"></ui-input>
            <ui-input label="Purchase Description" name="description" :error="form.errors.get('description')" v-model="form.description"></ui-input>
            <ui-input :label="`Quantity Of Purchase (${material.unit_of_measure})`" name="quantity_of_purchase" :error="form.errors.get('quantity_of_purchase')" v-model="form.quantity_of_purchase"></ui-input>
            <ui-input label="VAT Rate" name="vat_rate" :error="form.errors.get('vat_rate')" v-model="form.vat_rate"></ui-input>
            <ui-field label="Last Updated">{{ item.last_updated }}</ui-field>
        </ui-form-section>

        <div class="flex justify-end space-x-4">
            <ui-button-new @click="close">Cancel</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Save</ui-button-new>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        material: Object,
        item: Object,
        close: Function,
    },
    data () {
        return {
            form: new Form(this.item.getFormAttributes(), async (form) => {
                await this.item.update(form.export())

                this.close()
            }),
        }
    },
}
</script>
